export const SUPPORTED_LOCALES = [{
  code: 'en',
  base: '',
  flag: 'en',
  name: 'English',
  translations: '/translations/en.json'
}, {
  code: 'fr',
  base: '/fr',
  flag: 'fr',
  name: 'Français',
  translations: '/translations/fr.json'
},
{
  code: 'en-us',
  base: '/en-us',
  flag: 'en-us',
  name: 'American English',
  translations: '/translations/en-us.json'
},
{
  code: 'en-uk',
  base: '/en-uk',
  flag: 'en-uk',
  name: 'English UK',
  translations: '/translations/en-uk.json'
},
{
  code: 'de',
  base: '/de',
  flag: 'de',
  name: 'German',
  translations: '/translations/de.json'
},
{
  code: 'it',
  base: '/it',
  flag: 'it',
  name: 'Italian',
  translations: '/translations/it.json'
},
{
  code: 'es',
  base: '/es',
  flag: 'es',
  name: 'Spanish',
  translations: '/translations/es.json'
},
{
  code: 'es-mx',
  base: '/es-mx',
  flag: 'es-mx',
  name: 'Mexican Spanish',
  translations: '/translations/es-mx.json'
},
{
  code: 'pt',
  base: '/pt',
  flag: 'pt',
  name: 'Portuguese',
  translations: '/translations/pt.json'
},
{
  code: 'pt-br',
  base: '/pt-br',
  flag: 'pt-br',
  name: 'Brazilian Portuguese ',
  translations: '/translations/pt-br.json'
}]
